/**
 * 产品媒体预分组功能 - 重构版本
 * 根据接口获取变体数据和媒体数据，按属性组合进行分组
 * 优化数据流和事件处理逻辑
 */

function getSectionRoot(el) {
  return el.closest("[data-section-id]");
}

function getProductData() {
  const sectionEl = document.querySelector(".product-info-container");
  if (!sectionEl) {
    return { product: null, sectionId: null, sectionEl: null };
  }

  const sectionId = sectionEl.getAttribute("data-section-id");
  let el = null;

  if (sectionId) {
    el = sectionEl.querySelector(`#ProductJson-${sectionId}`);
  }

  if (!el) {
    el = sectionEl.querySelector('[id^="ProductJson-"]');
  }

  let product = null;
  try {
    product = el ? JSON.parse(el.textContent) : null;
  } catch (e) {}

  return { product, sectionId, sectionEl };
}

function findVariantById(product, id) {
  if (!product || !product.variants) return null;
  const n = Number(id);
  return product.variants.find((v) => Number(v.id) === n) || null;
}

if (typeof ProductMediaPreGrouping !== "undefined") {
} else {
  class ProductMediaPreGrouping {
    constructor() {
      this.mediaGroups = null;
      this.combinations = null;
      this.currentCombination = null;
      this.isInitialized = false;
      this.isProcessingVariantChange = false;
      this.lastProcessedVariantId = null;
      this.mediaUpdateTimeout = null;
      this.variantChangeHandler = null;
      this.lastMediaData = null;
    }

    async initialize() {
      try {
        if (this.isInitialized) {
          return true;
        }

        this.cleanupEventListeners();

        const productHandle = this.getProductHandle();
        if (!productHandle) {
          return false;
        }

        const productData = await this.fetchProductData(productHandle);
        if (!productData) {
          return false;
        }

        this.processMediaGrouping(productData);

        this.isInitialized = true;

        this.dispatchInitializationCompleteEvent();

        this.setupVariantChangeListener();

        this.waitForVariantDataAndInitialize();

        return true;
      } catch (error) {
        return false;
      }
    }

    cleanupEventListeners() {
      try {
        if (this.variantChangeHandler) {
          document.removeEventListener(
            "variant:change",
            this.variantChangeHandler
          );
        }

        if (this.mediaUpdateTimeout) {
          clearTimeout(this.mediaUpdateTimeout);
          this.mediaUpdateTimeout = null;
        }

        this.isProcessingVariantChange = false;
        this.lastProcessedVariantId = null;
      } catch (error) {}
    }

    getProductHandle() {
      const path = window.location.pathname;
      const match = path.match(/\/products\/([^\/]+)/);
      if (match) {
        return match[1];
      }

      if (window.product && window.product.handle) {
        return window.product.handle;
      }

      return null;
    }

    async fetchProductData(productHandle) {
      try {
        const productResponse = await fetch(`/products/${productHandle}.js`);
        if (!productResponse.ok) {
          throw new Error(`HTTP ${productResponse.status}`);
        }
        const productData = await productResponse.json();

        const allVariants = await this.fetchAllVariants(productHandle);

        if (
          allVariants.length === 0 &&
          productData.variants &&
          productData.variants.length > 0
        ) {
        } else if (allVariants.length > 0) {
          const mergedVariants = this.mergeVariantData(
            productData.variants,
            allVariants
          );
          productData.variants = mergedVariants;

          if (window.product) {
            window.product.variants = mergedVariants;

            const event = new CustomEvent("variantsDataUpdated", {
              detail: { variantsCount: mergedVariants.length },
            });
            document.dispatchEvent(event);
          }

          this.updateProductJSONScript(mergedVariants);
        }

        return productData;
      } catch (error) {
        return null;
      }
    }

    mergeVariantData(originalVariants, newVariants) {
      try {
        const originalVariantMap = new Map();
        if (originalVariants && originalVariants.length > 0) {
          originalVariants.forEach((variant) => {
            originalVariantMap.set(variant.id, variant);
          });
        }
        const mergedVariants = newVariants.map((newVariant) => {
          const originalVariant = originalVariantMap.get(newVariant.id);
          if (originalVariant) {
            return {
              ...originalVariant,
              price: newVariant.price,
              compare_at_price: newVariant.compare_at_price,
              sku: newVariant.sku,
              inventory_quantity: newVariant.inventory_quantity,
              inventory_management: newVariant.inventory_management,
              inventory_policy: newVariant.inventory_policy,
              fulfillment_service: newVariant.fulfillment_service,
              requires_shipping: newVariant.requires_shipping,
              taxable: newVariant.taxable,
              weight: newVariant.weight,
              weight_unit: newVariant.weight_unit,
              grams: newVariant.grams,
              image_id: newVariant.image_id,
              position: newVariant.position,
              created_at: newVariant.created_at,
              updated_at: newVariant.updated_at,
            };
          } else {
            return newVariant;
          }
        });

        return mergedVariants;
      } catch (error) {
        return newVariants;
      }
    }

    updateProductJSONScript(allVariants) {
      try {
        const productJsonScript = document.querySelector(
          'script[type="application/json"][id^="ProductJson-"]'
        );
        if (productJsonScript) {
          const productData = JSON.parse(productJsonScript.textContent);
          productData.variants = allVariants;
          productJsonScript.textContent = JSON.stringify(productData);
        }
      } catch (error) {}
    }

    async fetchAllVariants(productHandle) {
      try {
        let allVariants = [];
        let currentPage = 1;
        let hasNextPage = true;
        let pageCount = 0;

        while (hasNextPage && pageCount < 10) {
          pageCount++;

          let url = `/products/${productHandle}/variants.json?limit=250&page=${currentPage}`;

          const response = await fetch(url);
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }

          const data = await response.json();
          const currentPageVariants = data.product.variants || [];

          allVariants = allVariants.concat(currentPageVariants);

          if (currentPageVariants.length < 250) {
            hasNextPage = false;
          } else {
            currentPage++;
          }
        }

        return allVariants;
      } catch (error) {
        return [];
      }
    }

    processMediaGrouping(productData) {
      const variants = productData.variants || [];
      const media = productData.media || [];

      this.mediaGroups = {};
      this.combinations = {};

      variants.forEach((variant) => {
        const combination = this.createCombinationKey(variant);
        this.combinations[combination] = {
          variant: variant,
          media: this.getVariantMedia(variant, media),
        };
      });
    }

    getComboAttribute(variant) {
      if (variant.options && variant.options.length > 0) {
        const comboOption = variant.options[variant.options.length - 1];
        const optionValue = comboOption.includes("|")
          ? comboOption.split("|")[0].trim()
          : comboOption.trim();
        return optionValue.toLowerCase().replace(/\s+/g, "-");
      }

      if (variant.option3) {
        const optionValue = variant.option3.includes("|")
          ? variant.option3.split("|")[0].trim()
          : variant.option3.trim();
        return optionValue.toLowerCase().replace(/\s+/g, "-");
      }

      return null;
    }

    getDimensionAltText(variant) {
      const combinationKey = this.createCombinationKey(variant);
      const comboAttribute = this.getComboAttribute(variant);

      const fullAttributeDimension = combinationKey + "-dimension";
      const comboAttributeDimension = comboAttribute
        ? comboAttribute + "-dimension"
        : null;

      return {
        fullAttribute: fullAttributeDimension,
        comboAttribute: comboAttributeDimension,
      };
    }

    createCombinationKey(variant) {
      const extractOptionValue = (option) => {
        if (!option || typeof option !== "string") {
          return "";
        }
        let value = option.trim();

        if (value.includes("&")) {
          value = value.split("&")[0].trim();
        }

        if (value.includes("|")) {
          value = value.split("|")[0].trim();
        }

        return value;
      };

      if (variant.options && variant.options.length > 0) {
        const combinationKey = variant.options
          .map((option) => {
            let optionValue = extractOptionValue(option);

            if (/^\d+$/.test(optionValue)) {
              return null;
            }

            return optionValue.toLowerCase().replace(/\s+/g, "-");
          })
          .filter((option) => option && option.length > 0)
          .join("-");

        return combinationKey;
      }

      const options = [];
      if (variant.option1) options.push(variant.option1);
      if (variant.option2) options.push(variant.option2);
      if (variant.option3) options.push(variant.option3);

      if (options.length === 0) {
        return "default";
      }

      const combinationKey = options
        .map((option) => {
          let optionValue = extractOptionValue(option);

          if (/^\d+$/.test(optionValue)) {
            return null;
          }

          return optionValue.toLowerCase().replace(/\s+/g, "-");
        })
        .filter((option) => option && option.length > 0)
        .join("-");

      return combinationKey;
    }

    getVariantMedia(variant, allMedia) {
      const variantMedia = [];
      if (!variant) {
        return [];
      }

      if (!allMedia || !Array.isArray(allMedia)) {
        return [];
      }

      allMedia.forEach((mediaItem) => {
        if (this.isMediaForVariant(mediaItem, variant)) {
          const processedMedia = {
            ...mediaItem,
            sortOrder: this.getMediaSortOrder(mediaItem, variant),
          };

          variantMedia.push(processedMedia);
        }
      });

      return variantMedia.sort((a, b) => a.sortOrder - b.sortOrder);
    }

    getMediaSortOrder(mediaItem, variant) {
      const altText = (mediaItem.alt || "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-");
      const combinationKey = this.createCombinationKey(variant);

      if (altText === combinationKey) {
        return 1;
      }

      if (altText.startsWith(combinationKey + "-detail")) {
        return 3;
      }

      if (altText === "#common-video") {
        return 4;
      }

      if (altText === "#common") {
        return 5;
      }

      const dimensionAltTexts = this.getDimensionAltText(variant);
      if (
        dimensionAltTexts.fullAttribute &&
        altText === dimensionAltTexts.fullAttribute
      ) {
        return 2;
      }
      if (
        dimensionAltTexts.comboAttribute &&
        altText === dimensionAltTexts.comboAttribute
      ) {
        return 2;
      }

      return 999;
    }

    isMediaForVariant(mediaItem, variant) {
      const altText = (mediaItem.alt || "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-");
      const combinationKey = this.createCombinationKey(variant);
      if (!altText || altText.trim() === "") {
        return false;
      }
      if (altText === combinationKey) {
        return true;
      }
      if (altText.startsWith(combinationKey + "-detail")) {
        return true;
      }
      if (altText === "#common-video") {
        return true;
      }
      if (altText === "#common") {
        return true;
      }
      const dimensionAltTexts = this.getDimensionAltText(variant);
      if (
        dimensionAltTexts.fullAttribute &&
        altText === dimensionAltTexts.fullAttribute
      ) {
        return true;
      }
      if (
        dimensionAltTexts.comboAttribute &&
        altText === dimensionAltTexts.comboAttribute
      ) {
        return true;
      }
      return false;
    }
    async waitForVariantDataAndInitialize() {
      try {
        let attempts = 0;
        const maxAttempts = 50;

        while (attempts < maxAttempts) {
          if (
            window.product &&
            window.product.variants &&
            window.product.variants.length > 0
          ) {
            const currentVariant = this.getCurrentVariant();
            if (currentVariant) {
              this.initializeCurrentVariantCarousel();
            }

            this.updateProductJSONWithNewMedia();
            return;
          }

          await new Promise((resolve) => setTimeout(resolve, 100));
          attempts++;
        }

        const currentVariant = this.getCurrentVariant();
        if (currentVariant) {
          this.initializeCurrentVariantCarousel();
        }
        this.updateProductJSONWithNewMedia();
      } catch (error) {}
    }

    getCurrentVariantId() {
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput && variantInput.value) {
        return variantInput.value;
      }

      const variantSelects = document.querySelector("variant-selects");
      if (variantSelects && variantSelects.currentVariantId) {
        return variantSelects.currentVariantId;
      }

      return null;
    }

    getCurrentVariant() {
      const variantId = this.getCurrentVariantId();
      if (!variantId) {
        return null;
      }

      if (window.product && window.product.variants) {
        const variant = window.product.variants.find(
          (v) => v.id === parseInt(variantId)
        );
        if (variant) {
          return variant;
        }
      }

      return null;
    }

    initializeCurrentVariantCarousel() {
      try {
        const currentVariant = this.getCurrentVariant();
        if (!currentVariant) {
          return;
        }

        this.updateCurrentCombination(currentVariant);
      } catch (error) {}
    }

    setupVariantChangeListener() {
      try {
        this.variantChangeHandler = this.debounce((event) => {
          this.handleVariantChangeEvent(event);
        }, 150);

        document.addEventListener("variant:change", this.variantChangeHandler, {
          once: false,
          passive: true,
        });
      } catch (error) {}
    }

    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    handleVariantChangeEvent(event) {
      const newVariant = event.detail?.variant;
      if (!newVariant || !newVariant.id) {
        return;
      }

      if (this.isProcessingVariantChange) {
        return;
      }

      if (this.lastProcessedVariantId === newVariant.id) {
        return;
      }

      this.isProcessingVariantChange = true;

      try {
        requestAnimationFrame(() => {
          this.updateCurrentCombination(newVariant);
          this.isProcessingVariantChange = false;
        });
      } catch (error) {
        this.isProcessingVariantChange = false;
      }
    }

    updateCurrentCombination(variant) {
      if (!this.isInitialized || !variant) {
        return null;
      }

      try {
        const combinationKey = this.createCombinationKey(variant);
        const combination = this.combinations[combinationKey];
        if (combination) {
          this.currentCombination = combination;
          this.lastProcessedVariantId = variant.id;

          this.renderMediaForVariant(combination);
          this.updateProductJSONWithNewMedia();
          return combination;
        }

        return null;
      } catch (error) {
        return null;
      }
    }

    renderMediaForVariant(combination) {
      try {
        const mediaGallery = document.querySelector("media-gallery");
        if (!mediaGallery) {
          return;
        }

        const mediaData = combination.media || [];

        if (
          this.lastMediaData &&
          JSON.stringify(this.lastMediaData) === JSON.stringify(mediaData)
        ) {
          return;
        }

        this.lastMediaData = mediaData;

        requestAnimationFrame(() => {
          const mediaUpdateEvent = new CustomEvent("mediaGalleryDataUpdated", {
            detail: {
              media: mediaData,
              combination: combination,
              variant: combination.variant,
            },
            bubbles: true,
          });

          mediaGallery.dispatchEvent(mediaUpdateEvent);
        });
      } catch (error) {}
    }

    getProcessedMediaData() {
      if (!this.isInitialized || !this.combinations) {
        return null;
      }

      return {
        combinations: this.combinations,
        mediaGroups: this.mediaGroups,
        currentCombination: this.currentCombination,
        currentMedia: this.getCurrentVariantMedia(),
      };
    }

    getCurrentVariantMedia() {
      if (!this.currentCombination || !this.combinations) {
        return [];
      }

      return this.currentCombination.media || [];
    }

    updateProductJSONWithNewMedia() {
      try {
        const processedData = this.getProcessedMediaData();
        if (!processedData) {
          return;
        }

        const productJsonScript = document.querySelector(
          'script[type="application/json"][id^="ProductJson-"]'
        );
        if (!productJsonScript) {
          return;
        }

        let productData;
        try {
          productData = JSON.parse(productJsonScript.textContent);
        } catch (e) {
          return;
        }
        const currentMedia = productData.media;
        const newMedia = processedData.currentCombination?.media;

        if (
          currentMedia &&
          newMedia &&
          JSON.stringify(currentMedia) === JSON.stringify(newMedia) &&
          productData.newMedia
        ) {
          return;
        }

        if (newMedia) {
          productData.media = newMedia;
        }

        productData.newMedia = processedData;

        requestAnimationFrame(() => {
          try {
            productJsonScript.textContent = JSON.stringify(
              productData,
              null,
              2
            );
          } catch (error) {}
        });

        if (window.product) {
          if (
            processedData.currentCombination &&
            processedData.currentCombination.media
          ) {
            window.product.media = processedData.currentCombination.media;
          }
          window.product.newMedia = processedData;
        }

        const eventDetail = {
          newMedia: processedData,
          combination: processedData.currentCombination,
        };

        document.dispatchEvent(
          new CustomEvent("productNewMediaUpdated", {
            detail: eventDetail,
          })
        );
      } catch (error) {}
    }
    getAllCombinations() {
      return this.combinations;
    }

    dispatchInitializationCompleteEvent() {
      const event = new CustomEvent("productMediaPreGroupingInitialized", {
        detail: {
          instance: this,
          processedData: this.getProcessedProductData(),
          timestamp: Date.now(),
        },
      });

      document.dispatchEvent(event);
    }

    getProcessedProductData() {
      if (!this.isInitialized) {
        return null;
      }

      const { product, sectionId, sectionEl } = getProductData();
      if (!product) {
        return null;
      }

      const processedProduct = {
        ...product,
        processedMedia: this.mediaGroups,
        combinations: this.combinations,
        currentCombination: this.currentCombination,
        isProcessed: true,
        processedAt: Date.now(),
      };
      return {
        product: processedProduct,
        sectionId,
        sectionEl,
      };
    }
  }

  if (typeof window.productMediaPreGrouping === "undefined") {
    window.productMediaPreGrouping = new ProductMediaPreGrouping();

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        window.productMediaPreGrouping.initialize();
      });
    } else {
      window.productMediaPreGrouping.initialize();
    }
  }
}
